module.exports = __webpack_public_path__ + "static/media/29FUNOV6.7697a936.jpg";